export const companyIndexPath = () => "/companies"
export const companySearchPath = (companyId) => `/companies/${companyId}`
export const searchResultsPath = (countyId, categoryId) => `/counties/${countyId}/categories/${categoryId}/companies`
export const landingPagePath = () => `/`

export const loginPath = () => `/admin`
export const adminCompaniesPath = () => `/admin/companies`
export const adminAdsPath = () => `/admin/ads`
export const adminCategoriesPath = () => `/admin/categories`

export const companyEditPath = (id) => `/admin/companies/${id}/edit`
export const companyNewPath = () => `/admin/companies/new`

export const categoryEditPath = (id) => `/admin/categories/${id}/edit`
export const categoryNewPath = () => `/admin/categories/new`

export const adEditPath = (id) => `/admin/ads/${id}/edit`
export const adNewPath = () => `/admin/ads/new`

export const infoPagePath = () => `/infopage`
export const contactPagePath = () => `/contact`



// WEBPACK FOOTER //
// src/utils/paths.jsx